import Authentication from "@pitom84/integrations-services/src/classes/authentication/Authentication"

export default function guest({ next, router }) {
  if(Authentication.isAuthenticated() && Authentication.emailIsVerified())
    return router.push({ name: "Avaliações" })

  return next()
}
